import React from 'react';
import Layout from '../components/Layout';
import ct1 from '../assets/ct-1.png';
import ct2 from '../assets/ct-2.png';
import ct3 from '../assets/ct-3.png';
import InteractiveTab from '../components/InteractiveTab';

const TESTIMONIALS = [
  {
    quote: "We didn’t just get a better website. We got a brand that speaks clearly, builds trust, and drives conversions. That’s what Payan nailed.",
    author: "Founder, B2B SaaS (Series A)",
    authorColor: "text-white"
  },
  {
    quote: "Payan isn’t just a design team they’re creative partners. The speed, clarity, and ownership they brought changed how we launch",
    author: "Growth Lead, Fintech Product",
    authorColor: "text-[#bfbfbf]"
  }
];

const TestimonialsPage = () => (
  <Layout>
    <section className="w-full flex justify-center items-center min-h-[70vh] bg-black mt-12 md:mt-20">
      <div className="w-full max-w-screen-xl mx-auto flex flex-col items-start text-left px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24">
        <h1
          className="text-white font-[500] font-bricolage-grotesque mb-6 leading-[1.1] text-left"
          style={{ fontFamily: 'Bricolage Grotesque', letterSpacing: '-1%' }}
        >
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-[72px] leading-tight">
            AI founders said it better<br/>than we ever could
          </span>
        </h1>
        <p
          className="text-white font-space-grotesk mb-10 text-left"
          style={{ fontFamily: 'Space Grotesk', letterSpacing: '-1%' }}
        >
          <span className="block text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-[32px] leading-snug md:leading-[46px] max-w-full md:max-w-4xl">
            We work with GTM teams to turn confusing websites & marketing assets into conversion machines. Here's how it changed their growth, pitch, and confidence
          </span>
        </p>
        <div className="w-full flex justify-start mb-12">
          <button
            className="text-white capitalize rounded-[10px] font-space-grotesk font-bold transition px-6 py-4 md:px-12 md:py-6 text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-[32px] shadow-lg"
            style={{ background: 'rgba(111, 67, 254, 1)', fontFamily: 'Space Grotesk', lineHeight: '100%' }}
          >
            Explore Success Stories
          </button>
        </div>
        {/* Video Section */}
        <div className="w-full flex justify-start my-16 md:my-20">
          <div className="w-full max-w-6xl aspect-video rounded-xl overflow-hidden border border-[#7B61FF] shadow-lg">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/6aqnYDehMMk?si=xdNWyYjAl7vPKxUz"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              style={{ minHeight: 300, background: '#000' }}
            ></iframe>
          </div>
        </div>
        {/* Testimonials Section */}
        <div className="w-full flex flex-col md:flex-row gap-8 justify-start items-stretch mb-16 md:mb-24">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="flex-1 border border-[#7B61FF] rounded-[16px] p-8 md:p-10 bg-black min-w-[260px] max-w-full md:max-w-[578px] min-h-[242px] flex flex-col justify-between shadow-lg text-left"
            >
              <p
                className="font-space-grotesk text-white mb-8 text-left"
                style={{
                  fontFamily: 'Space Grotesk',
                  fontWeight: 400,
                  fontSize: '2xl',
                  fontSize: '40px',
                  lineHeight: '48px',
                  letterSpacing: '-1%'
                }}
              >
                “{t.quote}”
              </p>
              <div
                className={`font-bricolage-grotesque font-semibold text-2xl md:text-3xl lg:text-4xl text-left`}
                style={{
                  fontFamily: 'Bricolage Grotesque',
                  fontWeight: 600,
                  fontSize: '32px',
                  lineHeight: '40px',
                  letterSpacing: '-1%',
                  color: 'rgba(255, 255, 255, 1)'
                }}
              >
                {t.author}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    {/* Recognition Section */}
    <section className="w-full flex justify-center items-center bg-black py-16">
      <div className="w-full max-w-screen-xl mx-auto flex flex-col items-center justify-center px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24">
        <h2
          className="text-white text-center mb-12"
          style={{
            fontFamily: 'Bricolage Grotesque',
            fontWeight: 400,
            fontSize: '48px', // slightly larger
            lineHeight: '60px',
            letterSpacing: '-1%',
            maxWidth: 1200,
            margin: '0 auto',
          }}
        >
          We’ve just begun but we’re already showing up<br/>where the best studio’s are
        </h2>
        <div className="flex flex-row items-center justify-center gap-12 mb-20 md:mb-28 flex-wrap w-full">
          <img src={ct1} alt="CT1" style={{ width: 302.55, height: 141 }} />
          <img src={ct2} alt="CT2" style={{ width: 306.68, height: 87 }} />
          <img src={ct3} alt="CT3" style={{ width: 166.76, height: 224 }} />
        </div>
        <h2
          className="text-white text-left w-full"
          style={{
            fontFamily: 'Bricolage Grotesque',
            fontWeight: 500,
            fontSize: '48px',
            lineHeight: '60px',
            letterSpacing: '-1%',
            maxWidth: 1143,
          }}
        >
          Ready to turn your website or<br/>GTM assets into a growth engine?
        </h2>
      </div>
    </section>
    <section className="w-full flex justify-center items-center px-4 sm:px-6 lg:px-12 xl:px-16 2xl:px-24 mt-16 md:mt-3 mb-8">
      <div className="w-full max-w-screen-xl mx-auto">
        <InteractiveTab />
      </div>
    </section>
  </Layout>
);

export default TestimonialsPage; 